//TODO inheritance for each mfe
import { createSelector } from '@ngrx/store';

import { AppState } from '@pmis3/data-access';
import {
    VesselScheduleState,
    VesselScheduleStateStatus,
} from '../reducers/vesselSchedule.reducer';
import { Guid } from '@pmis3/utils';

export const vesselScheduleState = (state: AppState) =>
    state.vesselScheduleState;

export const selectVesselSchedules = createSelector(
    vesselScheduleState,
    (state: VesselScheduleState) => {
        console.log('state', state);
        return state.status == VesselScheduleStateStatus.LOADING
            ? []
            : state?.vesselSchedules?.items || [];
    }
);

export const selectVesselSchedulesForLocation = (locationId: Guid) =>
    createSelector(vesselScheduleState, (state: VesselScheduleState) => {
        console.log('state', state);
        return (
            state?.vesselSchedules?.items?.filter(
                (vs) => vs.locationId == locationId
            ) || []
        );
    });

export const selectVesselScheduleStateStatus = createSelector(
    vesselScheduleState,
    (state: VesselScheduleState) => state.status
);
